import { createContext, useContext } from "react"

export const DEFormContext = createContext()

export const useDEFormContext = () => {
    return useContext(DEFormContext)
}